import * as React from "react";
const SvgFiRrTachometerFastest = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tachometer-fastest_svg__a)">
      <path
        fill="#062147"
        d="M24 13a11.91 11.91 0 0 1-3.508 8.47 3.037 3.037 0 0 1-4.12.174l-1.026-.887a1 1 0 0 1 1.308-1.514l1.027.888a1.014 1.014 0 0 0 1.395-.075 10.044 10.044 0 0 0-.414-14.513 9.9 9.9 0 0 0-7.822-2.478 9.992 9.992 0 0 0-5.877 17.029 1 1 0 0 0 1.356.038l1.027-.89a1 1 0 0 1 1.308 1.515l-1.026.888a3.014 3.014 0 0 1-4.073-.13A12 12 0 1 1 24 13m-5.949 3.748a.998.998 0 0 0 1.428-.893 1 1 0 0 0-.628-.94l-4.863-2.135a2 2 0 1 0-.8 1.832z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tachometer-fastest_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTachometerFastest;
